function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.12 12l9.44-9.44c.59-.59.59-1.54 0-2.12a1.49 1.49 0 00-2.12 0L12 9.88 2.56.44a1.49 1.49 0 00-2.12 0 1.49 1.49 0 000 2.12L9.88 12 .44 21.44a1.49 1.49 0 000 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44L12 14.12l9.44 9.44c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12L14.12 12z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default __webpack_public_path__ + "0b03cc03e6fea058baa58dff983c243d.svg";
export { SvgClose as ReactComponent };